export const instructions =
  'Human Development Index - The Human Development Index is a statistical composite index used to measure countries’ levels of social and economic development using factors like schooling, life expectancy, and gross national income. Hiring in a lower HDI location can help improve workers’ access to global opportunities.';

export const HDIRatingLabels: { [key: string]: string } = {
  VERY_HIGH: 'Very High',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
};

export const humanDevelopmentIndex = [
  {
    countryCode: 'CH',
    index: 0.962,
    rating: 'VERY_HIGH',
    countryName: 'Switzerland',
  },
  {
    countryCode: 'NO',
    index: 0.961,
    rating: 'VERY_HIGH',
    countryName: 'Norway',
  },
  {
    countryCode: 'IS',
    index: 0.959,
    rating: 'VERY_HIGH',
    countryName: 'Iceland',
  },
  {
    countryCode: 'HK',
    index: 0.952,
    rating: 'VERY_HIGH',
    countryName: 'Hong Kong',
  },
  {
    countryCode: 'AU',
    index: 0.951,
    rating: 'VERY_HIGH',
    countryName: 'Australia',
  },
  {
    countryCode: 'DK',
    index: 0.948,
    rating: 'VERY_HIGH',
    countryName: 'Denmark',
  },
  {
    countryCode: 'SE',
    index: 0.947,
    rating: 'VERY_HIGH',
    countryName: 'Sweden',
  },
  {
    countryCode: 'IE',
    index: 0.945,
    rating: 'VERY_HIGH',
    countryName: 'Ireland',
  },
  {
    countryCode: 'DE',
    index: 0.942,
    rating: 'VERY_HIGH',
    countryName: 'Germany',
  },
  {
    countryCode: 'NL',
    index: 0.941,
    rating: 'VERY_HIGH',
    countryName: 'Netherlands',
  },
  {
    countryCode: 'FI',
    index: 0.94,
    rating: 'VERY_HIGH',
    countryName: 'Finland',
  },
  {
    countryCode: 'SG',
    index: 0.939,
    rating: 'VERY_HIGH',
    countryName: 'Singapore',
  },
  {
    countryCode: 'BE',
    index: 0.937,
    rating: 'VERY_HIGH',
    countryName: 'Belgium',
  },
  {
    countryCode: 'NZ',
    index: 0.937,
    rating: 'VERY_HIGH',
    countryName: 'New Zealand',
  },
  {
    countryCode: 'CA',
    index: 0.936,
    rating: 'VERY_HIGH',
    countryName: 'Canada',
  },
  {
    countryCode: 'LI',
    index: 0.935,
    rating: 'VERY_HIGH',
    countryName: 'Liechtenstein',
  },
  {
    countryCode: 'LU',
    index: 0.93,
    rating: 'VERY_HIGH',
    countryName: 'Luxembourg',
  },
  {
    countryCode: 'GB',
    index: 0.929,
    rating: 'VERY_HIGH',
    countryName: 'United Kingdom',
  },
  {
    countryCode: 'JP',
    index: 0.925,
    rating: 'VERY_HIGH',
    countryName: 'Japan',
  },
  {
    countryCode: 'KR',
    index: 0.925,
    rating: 'VERY_HIGH',
    countryName: 'South Korea',
  },
  {
    countryCode: 'US',
    index: 0.921,
    rating: 'VERY_HIGH',
    countryName: 'United States of America',
  },
  {
    countryCode: 'IL',
    index: 0.919,
    rating: 'VERY_HIGH',
    countryName: 'Israel',
  },
  {
    countryCode: 'MT',
    index: 0.918,
    rating: 'VERY_HIGH',
    countryName: 'Malta',
  },
  {
    countryCode: 'SI',
    index: 0.918,
    rating: 'VERY_HIGH',
    countryName: 'Slovenia',
  },
  {
    countryCode: 'AT',
    index: 0.916,
    rating: 'VERY_HIGH',
    countryName: 'Austria',
  },
  {
    countryCode: 'AE',
    index: 0.911,
    rating: 'VERY_HIGH',
    countryName: 'United Arab Emirates',
  },
  {
    countryCode: 'ES',
    index: 0.905,
    rating: 'VERY_HIGH',
    countryName: 'Spain',
  },
  {
    countryCode: 'FR',
    index: 0.903,
    rating: 'VERY_HIGH',
    countryName: 'France',
  },
  {
    countryCode: 'CY',
    index: 0.896,
    rating: 'VERY_HIGH',
    countryName: 'Cyprus',
  },
  {
    countryCode: 'IT',
    index: 0.895,
    rating: 'VERY_HIGH',
    countryName: 'Italy',
  },
  {
    countryCode: 'EE',
    index: 0.89,
    rating: 'VERY_HIGH',
    countryName: 'Estonia',
  },
  {
    countryCode: 'CZ',
    index: 0.889,
    rating: 'VERY_HIGH',
    countryName: 'Czechia',
  },
  {
    countryCode: 'GR',
    index: 0.887,
    rating: 'VERY_HIGH',
    countryName: 'Greece',
  },
  {
    countryCode: 'PL',
    index: 0.876,
    rating: 'VERY_HIGH',
    countryName: 'Poland',
  },
  {
    countryCode: 'BH',
    index: 0.875,
    rating: 'VERY_HIGH',
    countryName: 'Bahrain',
  },
  {
    countryCode: 'LT',
    index: 0.875,
    rating: 'VERY_HIGH',
    countryName: 'Lithuania',
  },
  {
    countryCode: 'SA',
    index: 0.875,
    rating: 'VERY_HIGH',
    countryName: 'Saudi Arabia',
  },
  {
    countryCode: 'PT',
    index: 0.866,
    rating: 'VERY_HIGH',
    countryName: 'Portugal',
  },
  {
    countryCode: 'LV',
    index: 0.863,
    rating: 'VERY_HIGH',
    countryName: 'Latvia',
  },
  {
    countryCode: 'AD',
    index: 0.858,
    rating: 'VERY_HIGH',
    countryName: 'Andorra',
  },
  {
    countryCode: 'HR',
    index: 0.858,
    rating: 'VERY_HIGH',
    countryName: 'Croatia',
  },
  {
    countryCode: 'CL',
    index: 0.855,
    rating: 'VERY_HIGH',
    countryName: 'Chile',
  },
  {
    countryCode: 'QA',
    index: 0.855,
    rating: 'VERY_HIGH',
    countryName: 'Qatar',
  },
  {
    countryCode: 'SM',
    index: 0.853,
    rating: 'VERY_HIGH',
    countryName: 'San Marino',
  },
  {
    countryCode: 'SK',
    index: 0.848,
    rating: 'VERY_HIGH',
    countryName: 'Slovakia',
  },
  {
    countryCode: 'HU',
    index: 0.846,
    rating: 'VERY_HIGH',
    countryName: 'Hungary',
  },
  {
    countryCode: 'AR',
    index: 0.842,
    rating: 'VERY_HIGH',
    countryName: 'Argentina',
  },
  {
    countryCode: 'TR',
    index: 0.838,
    rating: 'VERY_HIGH',
    countryName: 'Turkey',
  },
  {
    countryCode: 'ME',
    index: 0.832,
    rating: 'VERY_HIGH',
    countryName: 'Montenegro',
  },
  {
    countryCode: 'KW',
    index: 0.831,
    rating: 'VERY_HIGH',
    countryName: 'Kuwait',
  },
  {
    countryCode: 'BN',
    index: 0.829,
    rating: 'VERY_HIGH',
    countryName: 'Brunei',
  },
  {
    countryCode: 'RU',
    index: 0.822,
    rating: 'VERY_HIGH',
    countryName: 'Russia',
  },
  {
    countryCode: 'RO',
    index: 0.821,
    rating: 'VERY_HIGH',
    countryName: 'Romania',
  },
  {
    countryCode: 'OM',
    index: 0.816,
    rating: 'VERY_HIGH',
    countryName: 'Oman',
  },
  {
    countryCode: 'BS',
    index: 0.812,
    rating: 'VERY_HIGH',
    countryName: 'Bahamas',
  },
  {
    countryCode: 'KZ',
    index: 0.811,
    rating: 'VERY_HIGH',
    countryName: 'Kazakhstan',
  },
  {
    countryCode: 'TT',
    index: 0.81,
    rating: 'VERY_HIGH',
    countryName: 'Trinidad and Tobago',
  },
  {
    countryCode: 'CR',
    index: 0.809,
    rating: 'VERY_HIGH',
    countryName: 'Costa Rica',
  },
  {
    countryCode: 'UY',
    index: 0.809,
    rating: 'VERY_HIGH',
    countryName: 'Uruguay',
  },
  {
    countryCode: 'BY',
    index: 0.808,
    rating: 'VERY_HIGH',
    countryName: 'Belarus',
  },
  {
    countryCode: 'PA',
    index: 0.805,
    rating: 'VERY_HIGH',
    countryName: 'Panama',
  },
  {
    countryCode: 'MY',
    index: 0.803,
    rating: 'VERY_HIGH',
    countryName: 'Malaysia',
  },
  {
    countryCode: 'GE',
    index: 0.802,
    rating: 'VERY_HIGH',
    countryName: 'Georgia',
  },
  {
    countryCode: 'MU',
    index: 0.802,
    rating: 'VERY_HIGH',
    countryName: 'Mauritius',
  },
  {
    countryCode: 'RS',
    index: 0.802,
    rating: 'VERY_HIGH',
    countryName: 'Serbia',
  },
  {
    countryCode: 'TH',
    index: 0.8,
    rating: 'VERY_HIGH',
    countryName: 'Thailand',
  },
  {
    countryCode: 'AL',
    index: 0.796,
    rating: 'HIGH',
    countryName: 'Albania',
  },
  {
    countryCode: 'BG',
    index: 0.795,
    rating: 'HIGH',
    countryName: 'Bulgaria',
  },
  {
    countryCode: 'GD',
    index: 0.795,
    rating: 'HIGH',
    countryName: 'Grenada',
  },
  {
    countryCode: 'BB',
    index: 0.79,
    rating: 'HIGH',
    countryName: 'Barbados',
  },
  {
    countryCode: 'AG',
    index: 0.788,
    rating: 'HIGH',
    countryName: 'Antigua and Barbuda',
  },
  {
    countryCode: 'SC',
    index: 0.785,
    rating: 'HIGH',
    countryName: 'Seychelles',
  },
  {
    countryCode: 'LK',
    index: 0.782,
    rating: 'HIGH',
    countryName: 'Sri Lanka',
  },
  {
    countryCode: 'BA',
    index: 0.78,
    rating: 'HIGH',
    countryName: 'Bosnia and Herzegovina',
  },
  {
    countryCode: 'KN',
    index: 0.777,
    rating: 'HIGH',
    countryName: 'Saint Kitts and Nevis',
  },
  {
    countryCode: 'IR',
    index: 0.774,
    rating: 'HIGH',
    countryName: 'Iran',
  },
  {
    countryCode: 'UA',
    index: 0.773,
    rating: 'HIGH',
    countryName: 'Ukraine',
  },
  {
    countryCode: 'MK',
    index: 0.77,
    rating: 'HIGH',
    countryName: 'North Macedonia',
  },
  {
    countryCode: 'CN',
    index: 0.768,
    rating: 'HIGH',
    countryName: 'China',
  },
  {
    countryCode: 'DO',
    index: 0.767,
    rating: 'HIGH',
    countryName: 'Dominican Republic',
  },
  {
    countryCode: 'MD',
    index: 0.767,
    rating: 'HIGH',
    countryName: 'Moldova',
  },
  {
    countryCode: 'PW',
    index: 0.767,
    rating: 'HIGH',
    countryName: 'Palau',
  },
  {
    countryCode: 'CU',
    index: 0.764,
    rating: 'HIGH',
    countryName: 'Cuba',
  },
  {
    countryCode: 'PE',
    index: 0.762,
    rating: 'HIGH',
    countryName: 'Peru',
  },
  {
    countryCode: 'AM',
    index: 0.759,
    rating: 'HIGH',
    countryName: 'Armenia',
  },
  {
    countryCode: 'MX',
    index: 0.758,
    rating: 'HIGH',
    countryName: 'Mexico',
  },
  {
    countryCode: 'BR',
    index: 0.754,
    rating: 'HIGH',
    countryName: 'Brazil',
  },
  {
    countryCode: 'CO',
    index: 0.752,
    rating: 'HIGH',
    countryName: 'Colombia',
  },
  {
    countryCode: 'VC',
    index: 0.751,
    rating: 'HIGH',
    countryName: 'Saint Vincent and the Grenadines',
  },
  {
    countryCode: 'MV',
    index: 0.747,
    rating: 'HIGH',
    countryName: 'Maldives',
  },
  {
    countryCode: 'DZ',
    index: 0.745,
    rating: 'HIGH',
    countryName: 'Algeria',
  },
  {
    countryCode: 'AZ',
    index: 0.745,
    rating: 'HIGH',
    countryName: 'Azerbaijan',
  },
  {
    countryCode: 'TO',
    index: 0.745,
    rating: 'HIGH',
    countryName: 'Tonga',
  },
  {
    countryCode: 'TM',
    index: 0.745,
    rating: 'HIGH',
    countryName: 'Turkmenistan',
  },
  {
    countryCode: 'EC',
    index: 0.74,
    rating: 'HIGH',
    countryName: 'Ecuador',
  },
  {
    countryCode: 'MN',
    index: 0.739,
    rating: 'HIGH',
    countryName: 'Mongolia',
  },
  {
    countryCode: 'EG',
    index: 0.731,
    rating: 'HIGH',
    countryName: 'Egypt',
  },
  {
    countryCode: 'TN',
    index: 0.731,
    rating: 'HIGH',
    countryName: 'Tunisia',
  },
  {
    countryCode: 'FJ',
    index: 0.73,
    rating: 'HIGH',
    countryName: 'Fiji',
  },
  {
    countryCode: 'SR',
    index: 0.73,
    rating: 'HIGH',
    countryName: 'Suriname',
  },
  {
    countryCode: 'UZ',
    index: 0.727,
    rating: 'HIGH',
    countryName: 'Uzbekistan',
  },
  {
    countryCode: 'DM',
    index: 0.72,
    rating: 'HIGH',
    countryName: 'Dominica',
  },
  {
    countryCode: 'JO',
    index: 0.72,
    rating: 'HIGH',
    countryName: 'Jordan',
  },
  {
    countryCode: 'LY',
    index: 0.718,
    rating: 'HIGH',
    countryName: 'Libya',
  },
  {
    countryCode: 'PY',
    index: 0.717,
    rating: 'HIGH',
    countryName: 'Paraguay',
  },
  {
    countryCode: 'PS',
    index: 0.715,
    rating: 'HIGH',
    countryName: 'Palestine',
  },
  {
    countryCode: 'LC',
    index: 0.715,
    rating: 'HIGH',
    countryName: 'Saint Lucia',
  },
  {
    countryCode: 'GY',
    index: 0.714,
    rating: 'HIGH',
    countryName: 'Guyana',
  },
  {
    countryCode: 'ZA',
    index: 0.713,
    rating: 'HIGH',
    countryName: 'South Africa',
  },
  {
    countryCode: 'JM',
    index: 0.709,
    rating: 'HIGH',
    countryName: 'Jamaica',
  },
  {
    countryCode: 'WS',
    index: 0.707,
    rating: 'HIGH',
    countryName: 'Samoa',
  },
  {
    countryCode: 'GA',
    index: 0.706,
    rating: 'HIGH',
    countryName: 'Gabon',
  },
  {
    countryCode: 'LB',
    index: 0.705,
    rating: 'HIGH',
    countryName: 'Lebanon',
  },
  {
    countryCode: 'ID',
    index: 0.705,
    rating: 'HIGH',
    countryName: 'Indonesia',
  },
  {
    countryCode: 'VN',
    index: 0.703,
    rating: 'HIGH',
    countryName: 'Vietnam',
  },
  {
    countryCode: 'PH',
    index: 0.699,
    rating: 'MEDIUM',
    countryName: 'Philippines',
  },
  {
    countryCode: 'BW',
    index: 0.693,
    rating: 'MEDIUM',
    countryName: 'Botswana',
  },
  {
    countryCode: 'BO',
    index: 0.692,
    rating: 'MEDIUM',
    countryName: 'Bolivia',
  },
  {
    countryCode: 'KG',
    index: 0.692,
    rating: 'MEDIUM',
    countryName: 'Kyrgyzstan',
  },
  {
    countryCode: 'VE',
    index: 0.691,
    rating: 'MEDIUM',
    countryName: 'Venezuela',
  },
  {
    countryCode: 'IQ',
    index: 0.686,
    rating: 'MEDIUM',
    countryName: 'Iraq',
  },
  {
    countryCode: 'TJ',
    index: 0.685,
    rating: 'MEDIUM',
    countryName: 'Tajikistan',
  },
  {
    countryCode: 'BZ',
    index: 0.683,
    rating: 'MEDIUM',
    countryName: 'Belize',
  },
  {
    countryCode: 'MA',
    index: 0.675,
    rating: 'MEDIUM',
    countryName: 'Morocco',
  },
  {
    countryCode: 'SV',
    index: 0.675,
    rating: 'MEDIUM',
    countryName: 'El Salvador',
  },
  {
    countryCode: 'NI',
    index: 0.667,
    rating: 'MEDIUM',
    countryName: 'Nicaragua',
  },
  {
    countryCode: 'BT',
    index: 0.666,
    rating: 'MEDIUM',
    countryName: 'Bhutan',
  },
  {
    countryCode: 'CV',
    index: 0.662,
    rating: 'MEDIUM',
    countryName: 'Cape Verde',
  },
  {
    countryCode: 'BD',
    index: 0.661,
    rating: 'MEDIUM',
    countryName: 'Bangladesh',
  },
  {
    countryCode: 'TV',
    index: 0.641,
    rating: 'MEDIUM',
    countryName: 'Tuvalu',
  },
  {
    countryCode: 'MH',
    index: 0.639,
    rating: 'MEDIUM',
    countryName: 'Marshall Islands',
  },
  {
    countryCode: 'IN',
    index: 0.633,
    rating: 'MEDIUM',
    countryName: 'India',
  },
  {
    countryCode: 'GH',
    index: 0.632,
    rating: 'MEDIUM',
    countryName: 'Ghana',
  },
  {
    countryCode: 'FM',
    index: 0.628,
    rating: 'MEDIUM',
    countryName: 'Micronesia',
  },
  {
    countryCode: 'GT',
    index: 0.627,
    rating: 'MEDIUM',
    countryName: 'Guatemala',
  },
  {
    countryCode: 'KI',
    index: 0.624,
    rating: 'MEDIUM',
    countryName: 'Kiribati',
  },
  {
    countryCode: 'HN',
    index: 0.621,
    rating: 'MEDIUM',
    countryName: 'Honduras',
  },
  {
    countryCode: 'ST',
    index: 0.618,
    rating: 'MEDIUM',
    countryName: 'Sao Tome and Principe',
  },
  {
    countryCode: 'NA',
    index: 0.615,
    rating: 'MEDIUM',
    countryName: 'Namibia',
  },
  {
    countryCode: 'LA',
    index: 0.607,
    rating: 'MEDIUM',
    countryName: 'Laos',
  },
  {
    countryCode: 'TP',
    index: 0.607,
    rating: 'MEDIUM',
    countryName: 'East Timor',
  },
  {
    countryCode: 'VU',
    index: 0.607,
    rating: 'MEDIUM',
    countryName: 'Vanuatu',
  },
  {
    countryCode: 'NP',
    index: 0.602,
    rating: 'MEDIUM',
    countryName: 'Nepal',
  },
  {
    countryCode: 'SZ',
    index: 0.597,
    rating: 'MEDIUM',
    countryName: 'Eswatini',
  },
  {
    countryCode: 'GQ',
    index: 0.596,
    rating: 'MEDIUM',
    countryName: 'Equatorial Guinea',
  },
  {
    countryCode: 'KH',
    index: 0.593,
    rating: 'MEDIUM',
    countryName: 'Cambodia',
  },
  {
    countryCode: 'ZW',
    index: 0.593,
    rating: 'MEDIUM',
    countryName: 'Zimbabwe',
  },
  {
    countryCode: 'AO',
    index: 0.586,
    rating: 'MEDIUM',
    countryName: 'Angola',
  },
  {
    countryCode: 'MM',
    index: 0.585,
    rating: 'MEDIUM',
    countryName: 'Myanmar',
  },
  {
    countryCode: 'SY',
    index: 0.577,
    rating: 'MEDIUM',
    countryName: 'Syria',
  },
  {
    countryCode: 'CM',
    index: 0.576,
    rating: 'MEDIUM',
    countryName: 'Cameroon',
  },
  {
    countryCode: 'KE',
    index: 0.575,
    rating: 'MEDIUM',
    countryName: 'Kenya',
  },
  {
    countryCode: 'CG',
    index: 0.571,
    rating: 'MEDIUM',
    countryName: 'Republic of the Congo',
  },
  {
    countryCode: 'ZM',
    index: 0.565,
    rating: 'MEDIUM',
    countryName: 'Zambia',
  },
  {
    countryCode: 'SB',
    index: 0.564,
    rating: 'MEDIUM',
    countryName: 'Solomon Islands',
  },
  {
    countryCode: 'KM',
    index: 0.558,
    rating: 'MEDIUM',
    countryName: 'Comoros',
  },
  {
    countryCode: 'PG',
    index: 0.558,
    rating: 'MEDIUM',
    countryName: 'Papua New Guinea',
  },
  {
    countryCode: 'MR',
    index: 0.556,
    rating: 'MEDIUM',
    countryName: 'Mauritania',
  },
  {
    countryCode: 'CI',
    index: 0.55,
    rating: 'MEDIUM',
    countryName: 'Ivory Coast',
  },
  {
    countryCode: 'TZ',
    index: 0.549,
    rating: 'LOW',
    countryName: 'Tanzania',
  },
  {
    countryCode: 'PK',
    index: 0.544,
    rating: 'LOW',
    countryName: 'Pakistan',
  },
  {
    countryCode: 'TG',
    index: 0.539,
    rating: 'LOW',
    countryName: 'Togo',
  },
  {
    countryCode: 'HT',
    index: 0.535,
    rating: 'LOW',
    countryName: 'Haiti',
  },
  {
    countryCode: 'NG',
    index: 0.535,
    rating: 'LOW',
    countryName: 'Nigeria',
  },
  {
    countryCode: 'RW',
    index: 0.534,
    rating: 'LOW',
    countryName: 'Rwanda',
  },
  {
    countryCode: 'BJ',
    index: 0.525,
    rating: 'LOW',
    countryName: 'Benin',
  },
  {
    countryCode: 'UG',
    index: 0.525,
    rating: 'LOW',
    countryName: 'Uganda',
  },
  {
    countryCode: 'LS',
    index: 0.514,
    rating: 'LOW',
    countryName: 'Lesotho',
  },
  {
    countryCode: 'MW',
    index: 0.512,
    rating: 'LOW',
    countryName: 'Malawi',
  },
  {
    countryCode: 'SN',
    index: 0.511,
    rating: 'LOW',
    countryName: 'Senegal',
  },
  {
    countryCode: 'DJ',
    index: 0.509,
    rating: 'LOW',
    countryName: 'Djibouti',
  },
  {
    countryCode: 'SD',
    index: 0.508,
    rating: 'LOW',
    countryName: 'Sudan',
  },
  {
    countryCode: 'MG',
    index: 0.501,
    rating: 'LOW',
    countryName: 'Madagascar',
  },
  {
    countryCode: 'GM',
    index: 0.5,
    rating: 'LOW',
    countryName: 'Gambia',
  },
  {
    countryCode: 'ET',
    index: 0.498,
    rating: 'LOW',
    countryName: 'Ethiopia',
  },
  {
    countryCode: 'ER',
    index: 0.492,
    rating: 'LOW',
    countryName: 'Eritrea',
  },
  {
    countryCode: 'GW',
    index: 0.483,
    rating: 'LOW',
    countryName: 'Guinea-Bissau',
  },
  {
    countryCode: 'LR',
    index: 0.481,
    rating: 'LOW',
    countryName: 'Liberia',
  },
  {
    countryCode: 'CD',
    index: 0.479,
    rating: 'LOW',
    countryName: 'Democratic Republic of the Congo',
  },
  {
    countryCode: 'AF',
    index: 0.478,
    rating: 'LOW',
    countryName: 'Afghanistan',
  },
  {
    countryCode: 'SL',
    index: 0.477,
    rating: 'LOW',
    countryName: 'Sierra Leone',
  },
  {
    countryCode: 'GN',
    index: 0.465,
    rating: 'LOW',
    countryName: 'Guinea',
  },
  {
    countryCode: 'YE',
    index: 0.455,
    rating: 'LOW',
    countryName: 'Yemen',
  },
  {
    countryCode: 'BF',
    index: 0.449,
    rating: 'LOW',
    countryName: 'Burkina Faso',
  },
  {
    countryCode: 'MZ',
    index: 0.446,
    rating: 'LOW',
    countryName: 'Mozambique',
  },
  {
    countryCode: 'ML',
    index: 0.428,
    rating: 'LOW',
    countryName: 'Mali',
  },
  {
    countryCode: 'BI',
    index: 0.426,
    rating: 'LOW',
    countryName: 'Burundi',
  },
  {
    countryCode: 'CF',
    index: 0.404,
    rating: 'LOW',
    countryName: 'Central African Republic',
  },
  {
    countryCode: 'NE',
    index: 0.4,
    rating: 'LOW',
    countryName: 'Niger',
  },
  {
    countryCode: 'TD',
    index: 0.394,
    rating: 'LOW',
    countryName: 'Chad',
  },
  {
    countryCode: 'SS',
    index: 0.385,
    rating: 'LOW',
    countryName: 'South Sudan',
  },
];
